import { render, staticRenderFns } from "./BorcluCardList.vue?vue&type=template&id=555f1d3f"
import script from "./BorcluCardList.vue?vue&type=script&lang=ts"
export * from "./BorcluCardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports